import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';
import { FileService } from '../_services/file.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-image-upload-dialog',
  templateUrl: './image-upload-dialog.component.html',
  styleUrls: ['./image-upload-dialog.component.scss'],
})
export class ImageUploadDialogComponent implements OnInit {
  public file = new FormControl('');
  public formData = new FormData();
  public selectedFile: any;
  public percentCompleted = 0.0;
  public isUploaded = false;
  public isUploading = false;
  public imageUrl = '';

  constructor(private fileService: FileService, public dialogRef: MatDialogRef<ImageUploadDialogComponent>) {}

  public ngOnInit(): void {}

  public onFileChange(files: File[]) {
    if (files.length > 0) {
      this.selectedFile = files[0];
    }
  }

  public startUpload() {
    this.formData.append('files', this.selectedFile);
    this.fileService.uploadFile(this.formData).subscribe(
      (event) => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.isUploading = true;
            this.percentCompleted = 0;
            this.isUploaded = false;
            break;

          case HttpEventType.UploadProgress:
            // Compute and show the % done:
            this.percentCompleted = Math.round((100 * event.loaded) / event.total);
            if (Math.round((100 * event.loaded) / event.total) === 100) {
              this.percentCompleted = 99;
            }
            break;

          case HttpEventType.Response:
            this.isUploaded = true;
            this.percentCompleted = 100;
            this.isUploading = false;
            this.imageUrl = event.body[0].server_path;
            break;
          case HttpEventType.DownloadProgress:
            break;
          default:
            console.log(event);
            break;
        }
      },
      (err) => {
        console.error('error: ', err);
      },
    );
  }
}
